<template>
  <b-container>
    <h1>{{ $t("tracking.cargoExpense.create") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>

    <b-form @submit.prevent="save">
      <b-row>
        <b-col sm="12" md="6" lg="6">
          <cargo-expense-crud-data
            ref="crud"
            :model="model"
            :modelstate="modelstate"
            :readonly="false"
            class="mb-4"
          >
          </cargo-expense-crud-data>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="6" lg="6">
          <div v-if="model.cargoExpenseOccurrenceId != null">
            <custom-value
              ref="customValue"
              :items.sync="model.customValues"
              :occurrenceId="model.cargoExpenseOccurrenceId"
              :id="'0'"
              :readonly="false"
              class="customValue"
            >
            </custom-value>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button type="submit" :disabled="submitted">
            {{ $t("geral.save") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <!-- {{ model }} -->
  </b-container>
</template>

<script>
// import CustomFields from "@/components_rms/trackingShippingCompany/cargoExpense/CustomFields.vue";
import CustomValue from "@/components_rms/trackingShippingCompany/cargoExpense/CustomValue.vue";
export default {
  name: "CargoExpenseCreate",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CargoExpenseCrudData: () =>
      import(
        "@/components_rms/trackingShippingCompany/cargoExpense/CargoExpenseCrudData.vue"
      ),
    // CustomFields,
    CustomValue,
  },
  props: {
    companyId: String,
    cargoId: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      cargo: null,
      submitted: false,
      modelstate: {},
      model: {},
      customFields: [],
      editField: false,
    };
  },
  created() {
    this.loadCargo()
      .then(() => {
        this.newModel();
      })
      .catch(() => {
        this.newModel();
      });
  },
  computed: {
    getUrlBackToList() {
      if (this.cargo) {
        return `/trackingShippingCompany/cargoExpense/list/${this.cargo.cargoId}`;
      }
      return `/trackingShippingCompany/cargo/list`;
    },
  },
  methods: {
    async loadCargo() {
      await this.$api
        .get(`/cargo/get/${this.cargoId}`)
        .then((response) => {
          let model = response.data;
          // model.weight = model.weight.toFixed(2);
          this.cargo = model;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    newModel() {
      let dateNow = new Date();

      if (this.cargo) {
        this.model = {
          adicionalInformation: "",
          attachments: [],
          branchName: this.cargo.companyBranchName,
          cargoExpenseId: 0,
          cargoId: this.cargo.cargoId,
          cargoExpenseTypeId: 0,
          cargoExpenseTypeDescription: "",
          clientName: this.cargo.clientName,
          driverName: this.cargo.driverName,
          date: dateNow.toLocaleString(),
          value: 0,
          responsability: 1,
          priority: 1,
          customValues: [],
        };
      } else {
        this.model = {
          adicionalInformation: "",
          attachments: [
            {
              attachment: "",
            },
          ],
          branchName: "",
          cargoExpenseId: 0,
          cargoId: 0,
          cargoExpenseTypeId: 0,
          cargoExpenseTypeDescription: "",
          cargoExpenseOccurrenceId: 0,
          clientName: "",
          driverName: "",
          date: dateNow.toLocaleString(),
          value:  0,
          responsability: 1,
          priority: 1,
          customValues: [],
        };
      }
    },
    save() {
      this.submitted = true;
      let crudData = this.$refs.crud.getDataAsOjbect();
      console.log(crudData);
      this.$api
        .post(`/v1/cargoExpense/create`, crudData)
        .then((response) => {
          console.log(response);
          if (response.data.success == false) {
            this.alert.error = response.data.title;
            this.$refs.danger.show();
            // this.model =
          } else {
            console.log(response);
            this.model = response.data;
            this.newModel();
            this.model.cargoExpenseOccurrenceId = 0;
            this.$refs.alert.show();
            this.modelstate = {};
            this.submitted = false;
          }
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = {};
          if (error.response) {
            if (error.response.status == 400) {
              console.log(error.response);
              console.log(error.response.data);
              console.log(error.response.data.errors);
              this.modelstate = error.response.data.errors;
              this.alert.error = "Verifique os dados informados";
            } else if (error.response.status == 404) {
              console.log(error.response.data.message);
              this.alert.error = error.response.data.message;
              this.$refs.danger.show();
              // console.log(error.response.data.errors);
            } else {
              if (error.response.data) {
                console.log(error.response.data);
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
            }
          } else {
            this.alert.error = error.message;
          }
          this.$refs.danger.show();
        });
    },
  },
};
</script>
<style scoped>
.btn_customField {
  margin-left: 50%;
  margin-top: -54px !important;
  width: auto;
}
.customValue {
  margin-left: 1%;
}
</style>